import { Component, OnInit } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";
import { ActivatedRoute } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { Title } from "@angular/platform-browser";
import { StateService } from "../state.service";
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-lang-wrapper',
  templateUrl: './lang-wrapper.component.html',
  styleUrls: ['./lang-wrapper.component.scss']
})
export class LangWrapperComponent implements OnInit {
  private company: any;

  constructor(private translate: TranslocoService,
              private route: ActivatedRoute,
              private cookieService: CookieService,
              private titleService: Title,
              private stateService: StateService,) {
  }

  ngOnInit(): void {
    var contextLang = undefined
    if ((window as any).contextFrontendConfiguration?.lang) {
      console.warn('langwrapper found context conf')
      contextLang = (window as any).contextFrontendConfiguration?.lang
      console.warn('langwrapper found context conf lang', contextLang)
    } else {
      console.warn('langwrapper did not find context')
    }

    const companyCode = this.stateService.getState().value.customCssCompanyCode;
    this.company = companyCode ? environment.companies.find(company=>company.code === companyCode) : undefined

    this.translate.langChanges$.subscribe((event) => {
      this.translateTitle();
    });

    this.translate.setActiveLang(contextLang || this.cookieService.get('lang') || localStorage.getItem('lang') || this.translate.getActiveLang() || 'de')


    this.route.queryParams.subscribe(params => {
      if (params.hasOwnProperty('lang')) {
        const lang = params['lang'];
        if (!lang) {
          const localStorageLang = localStorage.getItem('lang');
          if (localStorageLang) {
            this.translate.setActiveLang(localStorageLang);
          }
          return;
        } else {
          this.translate.setActiveLang(lang);
          localStorage.setItem('lang', lang);
        }
      }
    });

    this.translateTitle();
  }

  translateTitle() {
    if (this.company?.tabTitle) {
      const lang = this.translate.getActiveLang();
      const title = this.company.tabTitle[lang] || this.company.tabTitle['de'];
      this.titleService.setTitle(title);
    } else {
      this.translate.selectTranslate('app-title').subscribe((title) => {
        this.titleService.setTitle(title);
      });
    }
  }

}
